import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { fieldsSelector } from "../../redux/fieldsSlice";
import { error } from "../../redux/notificationSlice";
import { surveySelector, updateSurvey } from "../../redux/surveySlice";

import AdminInputs from "../admin-component/AdminInputs";
import SurveyForm from "../home/SurveyForm";

const EditSurvey = (props) => {
  const { fields } = useSelector(fieldsSelector);
  const survey = useSelector(surveySelector);
  const dispatch = useDispatch();

  const editSurvey = () => {
    let empty = [];
    fields.forEach((element) => {
      if (element.isRequired && !survey[element.name]) {
        empty.push(`${element.title} is required`);
      }
    });
    if (empty.length > 0) {
      dispatch(error(empty[0]));
      return;
    }
    if (survey.noOfSpacesPitchesBedSpaces < 0) {
      dispatch(error("Number of spaces cannot be less than 0"));
      return;
    }
    if (survey.assetInspectionOrder < 0) {
      dispatch(error("Asset inspection order cannot be less than 0"));
      return;
    }
    dispatch(updateSurvey(survey));
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      className="modalDrawer modalDrawerAdmin"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3>Edit Survey</h3>
          <div className="name">Survey Name</div>
          <div className="site">{survey.hdcAssetReference}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {fields.map((field) => (
          <AdminInputs key={field.id} field={field} />
        ))}
        <SurveyForm />
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn cta-primary-light" onClick={props.onHide}>
          Discard
        </Button>
        <Button className="btn cta-primary" onClick={() => editSurvey()}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditSurvey;
